module.exports = __webpack_public_path__ + "assets/pebbles.a24e3944.svg";